import ButtonDropdown from "@components/ButtonDropdown"
import { KeyBinding } from "@features/keymap/KeyBinding"
import { useKeymap } from "@features/keymap/useKeymap"
import { formatModifierKey } from "@features/keymap/keyShortcutFormatter"
import { BarChart, Edit, FactCheck, Settings } from "@mui/icons-material"
import { ListItemIcon, ListItemText, MenuItem, MenuList, Typography } from "@mui/material"
import { shortcuts } from "@features/keymap/shortcuts"

export type ConfigurationDropdownButtonProps = {
  onEditMetadataClick?: () => void
  onAddPostSamplingValidationClick?: () => void
  onAddDashboardConfigurationClick?: () => void
}

const ConfigurationDropdownButton = (props: ConfigurationDropdownButtonProps) => {
  const { getKeymaps } = useKeymap()
  const keymap = getKeymaps().byId

  return (
    <ButtonDropdown label="Configuration" icon={<Settings />}>
      <MenuList>
        <MenuItem onClick={props.onEditMetadataClick} title={keymap.get("edit-metadata")?.desc}>
          <KeyBinding bind={shortcuts["edit-metadata"]} onKeyDown={props.onEditMetadataClick} />
          <ListItemIcon>
            <Edit fontSize="small" />
          </ListItemIcon>
          <ListItemText>Edit graph metadata</ListItemText>
          <Typography variant="caption" color="text.secondary" sx={{ ml: 2 }}>
            {formatModifierKey("shift")}+M
          </Typography>
        </MenuItem>

        <MenuItem
          onClick={props.onAddPostSamplingValidationClick}
          title={keymap.get("edit-post-sampling-validation")?.desc}
        >
          <KeyBinding
            bind={shortcuts["edit-post-sampling-validation"]}
            onKeyDown={props.onAddPostSamplingValidationClick}
          />
          <ListItemIcon>
            <FactCheck fontSize="small" />
          </ListItemIcon>
          <ListItemText>Add post-sampling validation</ListItemText>
          <Typography variant="caption" color="text.secondary" sx={{ ml: 2 }}>
            {formatModifierKey("shift")}+V
          </Typography>
        </MenuItem>

        <MenuItem
          onClick={props.onAddDashboardConfigurationClick}
          title={keymap.get("edit-dashboard")?.desc}
        >
          <KeyBinding
            bind={shortcuts["edit-dashboard"]}
            onKeyDown={props.onAddDashboardConfigurationClick}
          />
          <ListItemIcon>
            <BarChart fontSize="small" />
          </ListItemIcon>
          <ListItemText>Add dashboard configuration</ListItemText>
          <Typography variant="caption" color="text.secondary" sx={{ ml: 2 }}>
            {formatModifierKey("shift")}+C
          </Typography>
        </MenuItem>
      </MenuList>
    </ButtonDropdown>
  )
}

export default ConfigurationDropdownButton
